import axios from '@/plugins/axios';

const SEARCH_CONDITION = '/save-search-condition';

export async function searchCondition() {
  try {
    const { data } = await axios.get(`${SEARCH_CONDITION}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function saveCondition(payload) {
  try {
    const { data } = await axios.put(`${SEARCH_CONDITION}/${payload.u_favourite_search_id}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function deleteCondition(payload) {
  try {
    const { data } = await axios.delete(`${SEARCH_CONDITION}/${payload.u_favourite_search_id}`);

    return data;
  } catch (error) {
    return { error };
  }
}
